import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export function SocialProofNotification() {
  const prefersReducedMotion = useReducedMotion();
  return <motion.aside aria-label="25 mujeres latinas de 50+ ya están transformando su vitalidad con Edad Radiante" aria-live="off" initial={prefersReducedMotion ? false : {
    opacity: 0,
    y: 12
  }} animate={prefersReducedMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: [0, 1, 1, 0, 0],
    y: [12, 0, 0, 8, 12]
  }} transition={prefersReducedMotion ? {
    duration: 0
  } : {
    duration: 8,
    ease: 'easeInOut',
    repeat: Infinity,
    times: [0, 0.1, 0.65, 0.82, 1]
  }} className="pointer-events-none fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-2xl border border-gold/60 bg-cream-light px-4 py-3 shadow-xl shadow-brown/15 sm:bottom-6 sm:left-6 sm:px-5" data-id="element-290">
      <p className="text-sm font-bold leading-relaxed text-brown" data-id="element-291">
        <span aria-hidden="true" data-id="element-292">🌿 </span>25 mujeres latinas de 50+ ya están
        transformando su vitalidad con Edad Radiante
      </p>
    </motion.aside>;
}